"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.purple = exports.green = exports.yellow = exports.red = exports.navy = exports.blue = exports.silver = exports.gray = exports.black = exports.white = exports.beige = exports.orange = void 0;
exports.orange = {
  600: "#652100",
  500: "#B03900",
  400: "#FC5200",
  300: "#FD864D",
  200: "#FEBA99",
  100: "#FFEEE6"
};
exports.beige = {
  500: "#FFCCA8",
  400: "#FFEADB",
  300: "#FFF0E6",
  200: "#FFF7F1",
  100: "#FFFDFB"
};
exports.white = "#FFFFFF";
exports.black = {
  300: "#020404",
  200: "#0D171C",
  100: "#13222A"
};
exports.gray = {
  600: "#384341",
  500: "#546461",
  400: "#7C928F",
  300: "#98A9A7",
  200: "#B4C0BE",
  100: "#CFD7D6"
};
exports.silver = {
  500: "#C7CFCE",
  400: "#E7E9E9",
  300: "#F2F4F4",
  200: "#F7F9F9",
  100: "#FDFDFD"
};
exports.blue = {
  500: "#00417D",
  400: "#005AAF",
  300: "#0081FA",
  200: "#7DC0FF",
  100: "#E5F2FF"
};
exports.navy = {
  500: "#15252D",
  400: "#254250",
  300: "#365E72",
  200: "#467B95",
  100: "#5C95B2"
};
exports.red = {
  500: "#822727",
  400: "#D63530",
  300: "#DB4D48",
  200: "#FEB2B2",
  100: "#FFF5F5"
};
exports.yellow = {
  500: "#7D6800",
  400: "#AF9200",
  300: "#FAD000",
  200: "#FFE97D",
  100: "#FFFBE5"
};
exports.green = {
  500: "#22543D",
  400: "#25855A",
  300: "#00FAB3",
  200: "#9AE6B4",
  100: "#F0FFF4"
};
exports.purple = {
  500: "#310050",
  400: "#56008B",
  300: "#7B00C7",
  200: "#C363FF",
  100: "#F3E0FF"
};